var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "base-modal-ex",
    {
      attrs: {
        active: _vm.isActive,
        "animation-in": _vm.animationIn,
        "animation-out": _vm.animationOut,
        "animation-duration": _vm.animationDuration,
        "can-cancel": false,
        "min-width": 60,
        "has-modal-card": "",
      },
      on: {
        "update:active": function ($event) {
          _vm.isActive = $event
        },
      },
    },
    [
      _c("header", { staticClass: "modal-card-head" }, [
        _c(
          "p",
          {
            staticClass: "modal-card-title",
            class: { "is-flex-items-center": _vm.showIcon },
          },
          [
            _vm.showIcon
              ? _c(
                  "span",
                  {
                    staticClass: "icon is-medium",
                    class: `has-text-${_vm.iconType}`,
                    staticStyle: { "margin-right": "0.5rem" },
                  },
                  [
                    _c("i", {
                      staticClass: "mdi mdi-36px",
                      class: `${_vm.iconName}`,
                    }),
                  ]
                )
              : _vm._e(),
            _c("span", [_vm._v("Document")]),
          ]
        ),
      ]),
      _c(
        "section",
        {
          staticClass: "modal-card-body p-0 m-0",
          staticStyle: { position: "relative" },
        },
        [
          _c("div", { staticClass: "columns p-0 m-0" }, [
            _c("div", { staticClass: "column is-2 p-0 m-0" }, [
              _c(
                "div",
                {
                  staticClass: "box p-0 m-0",
                  style: {
                    height: _vm.maxHeight,
                    overflowY: "auto",
                    overflowX: "hidden",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "columns is-multiline p-0 m-0" },
                    _vm._l(_vm.pageThumbnails, function (derived) {
                      return _c(
                        "div",
                        {
                          key: derived.quoteAttachmentId,
                          staticClass: "column is-full p-0 m-0",
                        },
                        [
                          _c(
                            "a",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.viewImage(derived)
                                },
                              },
                            },
                            [
                              _c(
                                "figure",
                                { staticClass: "image is-128x128" },
                                [
                                  _c("LazyImage", {
                                    staticClass: "image is-128x128",
                                    staticStyle: { "object-fit": "contain" },
                                    attrs: { src: derived.externalStorageURL },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              ),
            ]),
            _c("div", { staticClass: "column p-0 m-0" }, [
              _c("div", { staticClass: "box p-0 m-0" }, [
                _c(
                  "figure",
                  {
                    staticClass: "image",
                    on: {
                      click: function ($event) {
                        return _vm.editImage(_vm.mainImageDerived)
                      },
                    },
                  },
                  [
                    _c("LazyImage", {
                      staticClass: "image",
                      attrs: { src: _vm.mainImageLink },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ]
      ),
      _c("footer", { staticClass: "modal-card-foot" }, [
        _c(
          "div",
          {
            style: `width: 100%; display: flex; justify-content: space-between;`,
          },
          [
            _c("div", { staticStyle: { "align-self": "flex-start" } }, [
              _vm.isPDF && false
                ? _c(
                    "button",
                    {
                      staticClass: "button tooltip",
                      attrs: { "data-tooltip": "Cancel" },
                      on: {
                        click: () => {
                          _vm.toggleRedaction(true)
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "icon" }, [
                        _c("i", {
                          staticClass:
                            "mdi mdi-format-color-marker-cancel mdi-18px",
                        }),
                      ]),
                      _c("span", [_vm._v("Redact")]),
                    ]
                  )
                : _vm._e(),
              _c(
                "button",
                {
                  staticClass: "button",
                  on: {
                    click: () => {
                      _vm.downloadModifiedDocument()
                    },
                  },
                },
                [
                  _c("span", { staticClass: "icon" }, [
                    _c("i", {
                      staticClass:
                        "mdi mdi-format-color-marker-cancel mdi-18px",
                    }),
                  ]),
                  _c("span", [_vm._v("Download")]),
                ]
              ),
            ]),
            _c("div", { staticStyle: { "align-self": "flex-end" } }, [
              _c(
                "button",
                {
                  staticClass: "button tooltip",
                  attrs: { "data-tooltip": "Cancel" },
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [
                  _c("span", { staticClass: "icon" }, [
                    _c("i", { staticClass: "mdi mdi-close mdi-18px" }),
                  ]),
                  _c("span", [_vm._v("Close")]),
                ]
              ),
            ]),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }